import { ParksSquaresLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "d1f0bb16-85da-44d1-a093-e5edb808bb2b",
    label: "DG/P& S/300/2021-2022",
    date: "31.03.2022",
    subject:
      "Guideline For Issuance Of 'no-objection Cirtificate' Related To Cutting/felling Of Trees Under Parks & Squares Department",
  },
  {
    fileStoreId: "c8139e86-4ac6-4d66-85c1-1ae1fe4d2d9a",
    label: "DG/P& S/01/2022-2023",
    date: "04.04.2022",
    subject: "DG/P&S/01/2022-2023",
  },
];

const Office_Order = () => (
  <TableStructure
    title="Parks and Gardens"
    heading={false}
    list={List}
    columnNo={3}
    leftMenuList={ParksSquaresLeftMenuList}
    longMenuList={false}
  />
);

export default Office_Order;
